import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { fetchItemMaster, fetchSupplierMaster } from "./API";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import GstInfo from "./GstInfo";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowData,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import CtART from "./CustomTool/ResponsiveTable";

class SupplierMaster extends Component {
  state = {
    CrDr: [{ Type: "CR" }, { Type: "DR" }],
    CityList: [],
    StateList: [],
    columnsdata: [
      { accessorKey: "vac_gstno", header: "GST No" },
      { accessorKey: "vac_supplier", header: "Supplier Name" },
      { accessorKey: "vac_billingname", header: "Billing Name" },
      { accessorKey: "vac_personname", header: "Person Name" },
      { accessorKey: "vac_address", header: "Address" },
      { accessorKey: "vac_city", header: "City" },
      { accessorKey: "vac_state", header: "State" },
      { accessorKey: "vac_statecode", header: "State Code" },
      { accessorKey: "vac_panno", header: "Pan No" },
      { accessorKey: "vac_mobileno1", header: "Mobile No 1" },
      { accessorKey: "vac_mobileno2", header: "Mobile No 2" },
      { accessorKey: "vac_email1", header: "Email 1" },
      { accessorKey: "vac_email2", header: "Email 2" },
      { accessorKey: "vac_openingamountcrdr", header: "Cr/Dr" },
      { accessorKey: "dec_openingamount", header: "Opening Amount" },
      { accessorKey: "vac_remark", header: "Remark" },
    ],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      //  { id: 'bint_srno', label: 'SR NO' },
      // { id: "companycode", label: "Company Code", hide: "true" },
      // { id: "vac_company", label: "Company Name", hide: "true" },
      { id: "vac_gstno", label: "GST No" },
      { id: "vac_supplier", label: "Supplier Name" },
      { id: "vac_billingname", label: "Billing Name" },
      { id: "vac_personname", label: "Person Name" },
      { id: "vac_address", label: "Address" },
      { id: "vac_city", label: "City" },
      { id: "vac_state", label: "State" },
      { id: "vac_statecode", label: "State Code" },
      { id: "vac_panno", label: "Pan No" },
      { id: "vac_mobileno1", label: "Mobile No 1" },
      { id: "vac_mobileno2", label: "Mobile No 2" },
      { id: "vac_email1", label: "Email 1" },
      { id: "vac_email2", label: "Email 2" },
      { id: "vac_openingamountcrdr", label: "Cr/Dr" },
      { id: "dec_openingamount", label: "Opening Amount" },
      { id: "vac_remark", label: "Remark" },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "SupplierMaster:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "SupplierMaster:",
        actionType: "AlertResponsive",
      },
    ],
    keyColumn: [
      "vac_gstno", //0
      "vac_supplier", //1
      "vac_billingname", //2
      "vac_personname", //3
      "vac_address", //4
      "vac_city", //5
      "vac_state", //6
      "vac_statecode", //7
      "vac_panno", //8
      "vac_mobileno1", //9
      "vac_mobileno2", //10
      "vac_email1", //11
      "vac_email2", //12
      "vac_openingamountcrdr", //13
      "dec_openingamount", //14
      "vac_remark", //15
    ],
    searchData: {
      vac_gstno: "",
      vac_supplier: "",
      vac_billingname: "",
      vac_personname: "",
      vac_address: "",
      vac_city: "",
      vac_state: "",
      vac_statecode: "",
      vac_panno: "",
      vac_mobileno1: "",
      vac_mobileno2: "",
      vac_email1: "",
      vac_email2: "",
      vac_openingamountcrdr: "",
      dec_openingamount: "",
      vac_remark: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,
    formData: {
      EditSupplierName: "",
      txtGSTNo: "",
      txtSupplierName: "",
      txtBillingName: "",
      txtPersonName: "",
      txtAddress: "",
      cmbCity: "",
      cmbState: "Gujarat",
      txtStateCode: "24",
      txtPanNo: "",
      txtMobileNo1: "",
      txtMobileNo2: "",
      txtEmail1: "",
      txtEmail2: "",
      cmbCrDr: "CR",
      txtOpeningAmount: "",
      txtRemark: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
    GeneralSettingList: [],
  };

  //#region Component
  componentDidMount() {
    {
      !this.props.showHeading &&
        (document.title = "RiTe Account : Supplier Master");
    }
    this.props.setActiveMenu("SupplierMaster");
    this.ShortCut();
    this.setSearchColumns();
    this.props.verifyUserID(
      this.getInfo,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
    // this.getInfo();
  }
  componentWillUnmount() {
    this.removeShortCut();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "txtGSTNo") {
          let Gstno = this.state.formData.txtGSTNo.substring(2, 12);
          this.setState({
            formData: { ...this.state.formData, txtPanNo: Gstno },
          });
        } else if (e.target.name === "cmbState") {
          let txtStateCode = this.state.formData.txtStateCode;
          this.state.StateList.map((curState) => {
            if (e.target.value === curState.vac_state) {
              txtStateCode = curState.vac_statecode;
            }
          });
          this.setState({
            formData: { ...this.state.formData, txtStateCode },
          });
        }
      }
    );
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_gstno.length === 0 ||
            (row["vac_gstno"] &&
              row["vac_gstno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_gstno.toLowerCase()))) &&
          (this.state.searchData.vac_supplier.length === 0 ||
            (row["vac_supplier"] &&
              row["vac_supplier"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_supplier.toLowerCase()))) &&
          (this.state.searchData.vac_billingname.length === 0 ||
            (row["vac_billingname"] &&
              row["vac_billingname"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_billingname.toLowerCase()
                ))) &&
          (this.state.searchData.vac_personname.length === 0 ||
            (row["vac_personname"] &&
              row["vac_personname"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_personname.toLowerCase()
                ))) &&
          (this.state.searchData.vac_address.length === 0 ||
            (row["vac_address"] &&
              row["vac_address"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_address.toLowerCase()))) &&
          (this.state.searchData.vac_city === "" ||
            (row["vac_city"] &&
              row["vac_city"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_city.toLowerCase()))) &&
          (this.state.searchData.vac_state === "" ||
            (row["vac_state"] &&
              row["vac_state"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_state.toLowerCase()))) &&
          (this.state.searchData.vac_statecode.length === 0 ||
            (row["vac_statecode"] &&
              row["vac_statecode"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_statecode.toLowerCase()
                ))) &&
          (this.state.searchData.vac_panno.length === 0 ||
            (row["vac_panno"] &&
              row["vac_panno"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_panno.toLowerCase()))) &&
          (this.state.searchData.vac_mobileno1.length === 0 ||
            (row["vac_mobileno1"] &&
              row["vac_mobileno1"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_mobileno1.toLowerCase()
                ))) &&
          (this.state.searchData.vac_mobileno2.length === 0 ||
            (row["vac_mobileno2"] &&
              row["vac_mobileno2"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_mobileno2.toLowerCase()
                ))) &&
          (this.state.searchData.vac_email1.length === 0 ||
            (row["vac_email1"] &&
              row["vac_email1"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_email1.toLowerCase()))) &&
          (this.state.searchData.vac_email2.length === 0 ||
            (row["vac_email2"] &&
              row["vac_email2"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_email2.toLowerCase()))) &&
          (this.state.searchData.vac_openingamountcrdr === "" ||
            this.state.searchData.vac_openingamountcrdr ===
              row["vac_openingamountcrdr"]) &&
          (this.state.searchData.dec_openingamount.length === 0 ||
            (row["dec_openingamount"] &&
              row["dec_openingamount"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.dec_openingamount.toLowerCase()
                ))) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"] &&
              row["vac_remark"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_remark.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  vac_supplier;

  vac_personname;
  vac_address;
  vac_city;
  vac_state;
  vac_statecode;
  vac_panno;
  vac_mobileno1;
  vac_mobileno2;
  vac_email1;
  vac_email2;
  vac_openingamountcrdr;
  dec_openingamount;
  vac_remark;
  handleARDonActionClick = (row) => {
    const txtGSTNo = row.vac_gstno,
      EditSupplierName = row.vac_supplier,
      txtSupplierName = row.vac_supplier,
      txtBillingName = row.vac_billingname,
      txtPersonName = row.vac_personname,
      txtAddress = row.vac_address,
      cmbCity = row.vac_city,
      cmbState = row.vac_state,
      txtStateCode = row.vac_statecode,
      txtPanNo = row.vac_panno,
      txtMobileNo1 = row.vac_mobileno1,
      txtMobileNo2 = row.vac_mobileno2,
      txtEmail1 = row.vac_email1,
      txtEmail2 = row.vac_email2,
      cmbCrDr = row.vac_openingamountcrdr,
      txtOpeningAmount = row.dec_openingamount,
      txtRemark = row.vac_remark,
      actionName = row.actionName;
    if (actionName === "Edit") {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            txtGSTNo,
            EditSupplierName,
            txtSupplierName,
            txtBillingName,
            txtPersonName,
            txtAddress,
            cmbCity,
            cmbState,
            txtStateCode,
            txtPanNo,
            txtMobileNo1,
            txtMobileNo2,
            txtEmail1,
            txtEmail2,
            cmbCrDr,
            txtOpeningAmount,
            txtRemark,
          },
        },
        () => {
          window.scrollTo(0, 0);
          document.getElementById("txtGSTNo").focus();
        }
      );
    } else if (actionName === "Delete") {
      this.DeleteData(EditSupplierName);
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["vac_supplier"]),
      EditSupplierName = row.vac_supplier;
    this.DeleteData(EditSupplierName);
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "vac_gstno",
      "vac_supplier",
      "vac_supplier",
      "vac_billingname",
      "vac_personname",
      "vac_address",
      "vac_city",
      "vac_state",
      "vac_statecode",
      "vac_panno",
      "vac_mobileno1",
      "vac_mobileno2",
      "vac_email1",
      "vac_email2",
      "vac_openingamountcrdr",
      "dec_openingamount",
      "vac_remark",
    ]);

    const txtGSTNo = row.vac_gstno,
      EditSupplierName = row.vac_supplier,
      txtSupplierName = row.vac_supplier,
      txtBillingName = row.vac_billingname,
      txtPersonName = row.vac_personname,
      txtAddress = row.vac_address,
      cmbCity = row.vac_city,
      cmbState = row.vac_state,
      txtStateCode = row.vac_statecode,
      txtPanNo = row.vac_panno,
      txtMobileNo1 = row.vac_mobileno1,
      txtMobileNo2 = row.vac_mobileno2,
      txtEmail1 = row.vac_email1,
      txtEmail2 = row.vac_email2,
      cmbCrDr = row.vac_openingamountcrdr,
      txtOpeningAmount = row.dec_openingamount,
      txtRemark = row.vac_remark;

    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtGSTNo,
          EditSupplierName,
          txtSupplierName,
          txtBillingName,
          txtPersonName,
          txtAddress,
          cmbCity,
          cmbState,
          txtStateCode,
          txtPanNo,
          txtMobileNo1,
          txtMobileNo2,
          txtEmail1,
          txtEmail2,
          cmbCrDr,
          txtOpeningAmount,
          txtRemark,
        },
      },
      () => {
        window.scrollTo(0, 0);
        document.getElementById("txtGSTNo").focus();
      }
    );
  };

  //#endregion handle

  //#region function

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      {
        handleOnclickSave: this.SaveSupplierMaster,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: () => {
          this.DeleteData(this.state.formData.EditSupplierName);
        },
      }

      // this.saveSales(true)
    );
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "vac_gstno",
        label: "GST NO",
        value: this.state.searchData.vac_gstno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "15",
      },
      {
        cType: "CtTxt",
        id: "vac_supplier",
        label: "Supplier Name",
        value: this.state.searchData.vac_supplier,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_billingname",
        label: "Billing Name",
        value: this.state.searchData.vac_billingname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_personname",
        label: "Person Name",
        value: this.state.searchData.vac_personname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_address",
        label: "Address",
        value: this.state.searchData.vac_address,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_city",
        label: "City",
        items: this.state.City,
        value: this.state.searchData.vac_city,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_state",
        label: "State",
        items: this.state.State,
        value: this.state.searchData.vac_state,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_statecode",
        label: "State Code",
        value: this.state.searchData.vac_statecode,
        handleOnChange: this.handleOnSearchInputChange,
        width: "120",
        maxLength: "5",
      },
      {
        cType: "CtTxt",
        id: "vac_panno",
        label: "Pan No",
        value: this.state.searchData.vac_panno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "120",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_mobileno1",
        label: "Mobile 1",
        value: this.state.searchData.vac_mobileno1,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_mobileno2",
        label: "Mobile 2",
        value: this.state.searchData.vac_mobileno2,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "10",
      },
      {
        cType: "CtTxt",
        id: "vac_email1",
        label: "Email 1",
        value: this.state.searchData.vac_email1,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "50",
      },
      {
        cType: "CtTxt",
        id: "vac_email2",
        label: "Email 2",
        value: this.state.searchData.vac_email2,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "50",
      },
      {
        cType: "Lbl",
        label: "Cr/Dr",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Opening Amount",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateSupplierMaster = () => {
    let result = false;

    let AddressValidation = getRowData(
        this.state.GeneralSettingList,
        "vac_key",
        "Address Validation"
      ),
      MobNo1Validation = getRowData(
        this.state.GeneralSettingList,
        "vac_key",
        "Mobile No. 1 Validation"
      ),
      MobNo2Validation = getRowData(
        this.state.GeneralSettingList,
        "vac_key",
        "Mobile No. 2 Validation"
      );

    if (this.state.formData.txtSupplierName.length <= 0) {
      this.props.toastErrorMsg("Enter Supplier Name", "txtSupplierName");
    } else if (
      AddressValidation.vac_value === "Mandatory" &&
      this.state.formData.txtAddress.length <= 0
    ) {
      this.props.toastErrorMsg("Enter Address", "txtAddress");
    } else if (this.state.formData.cmbState.length <= 0) {
      this.props.toastErrorMsg("Enter State", "cmbState");
    } else if (
      this.state.formData.txtGSTNo.trim().length !== 0 &&
      this.state.formData.txtGSTNo.trim().length < 15
    ) {
      this.props.toastErrorMsg("Enter 15 Digit valid GSTIN", "txtGSTIN");
    } else if (
      this.state.formData.txtPanNo.trim().length !== 0 &&
      this.state.formData.txtPanNo.trim().length < 10
    ) {
      this.props.toastErrorMsg("Enter 10 Digit PAN NO", "txtPanNo");
    } else if (
      MobNo1Validation.vac_value === "Mandatory" &&
      this.state.formData.txtMobileNo1.trim().length <= 0
    ) {
      this.props.toastErrorMsg("Enter Mobile No. 1", "txtMobileNo1");
    } else if (
      this.state.formData.txtMobileNo1.trim().length !== 0 &&
      this.state.formData.txtMobileNo1.trim().length < 10
    ) {
      this.props.toastErrorMsg(
        "Enter 10 Digit valid Mobile No. 1",
        "txtMobileNo1"
      );
    } else if (
      MobNo2Validation.vac_value === "Mandatory" &&
      this.state.formData.txtMobileNo2.trim().length <= 0
    ) {
      this.props.toastErrorMsg("Enter Mobile No. 2", "txtMobileNo2");
    } else if (
      this.state.formData.txtMobileNo2.trim().length !== 0 &&
      this.state.formData.txtMobileNo2.trim().length < 10
    ) {
      this.props.toastErrorMsg(
        "Enter 10 Digit valid Mobile No 2",
        "txtMobileNo2"
      );
    } else if (
      this.state.formData.txtEmail1.trim().length !== 0 &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        this.state.formData.txtEmail1
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Email 1", "txtEmail1");
    } else if (
      this.state.formData.txtEmail2.trim().length !== 0 &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        this.state.formData.txtEmail2
      )
    ) {
      this.props.toastErrorMsg("Enter Valid Email 2", "txtEmail2");
    } else {
      result = true;
    }
    return result;
  };

  validateGstInfo = () => {
    let result = false;
    if (this.state.formData.txtGSTNo.trim().length <= 0) {
      this.props.toastErrorMsg("Enter GSTNO", "txtGSTNo");
    } else if (this.state.formData.txtGSTNo.trim().length < 15) {
      this.props.toastErrorMsg("Enter 15 Digit GSTNO", "txtGSTNo");
    } else {
      result = true;
    }
    return result;
  };

  getInfo = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadSupplierDetails",
        bolLoadState: true,
        bolLoadCity: true,
        bint_acid: localStorage.getItem("acid"),
        bolLoadGeneralSetting: true,
      };
      fetchSupplierMaster(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0,
            StateList = [],
            CityList = [],
            GeneralSettingList = res.data.GeneralSettingList;
          if (res.data.supplierList && res.data.supplierList.length > 0) {
            rows = res.data.supplierList;
            rowsCount = rows.length;
          }
          if (res.data.StateList && res.data.StateList.length > 0) {
            StateList = res.data.StateList;
          }
          if (res.data.CityList && res.data.CityList.length > 0) {
            CityList = res.data.CityList;
          }
          this.setState({
            dataLoadStatus,
            rowsCount,
            rows,
            StateList,
            CityList,
            GeneralSettingList,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in getInfo.", error);
        });
    });
    document.getElementById("txtSupplierName").focus();
  };

  clearInfo = () => {
    const EditSupplierName = "",
      txtSupplierName = "",
      txtBillingName = "",
      txtPersonName = "",
      txtAddress = "",
      cmbCity = "",
      cmbState = "Gujarat",
      txtStateCode = "24",
      txtGSTIN = "",
      txtPanNo = "",
      txtMobileNo1 = "",
      txtMobileNo2 = "",
      txtEmail1 = "",
      txtEmail2 = "",
      cmbCrDr = "CR",
      txtOpeningAmount = "",
      txtRemark = "",
      txtGSTNo = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          EditSupplierName,
          txtGSTNo,
          txtSupplierName,
          txtBillingName,
          txtPersonName,
          txtAddress,
          cmbCity,
          cmbState,
          txtStateCode,
          txtGSTIN,
          txtPanNo,
          txtMobileNo1,
          txtMobileNo2,
          txtEmail1,
          txtEmail2,
          cmbCrDr,
          txtOpeningAmount,
          txtRemark,
        },
      },
      () => {
        document.getElementById("txtSupplierName").focus();
      }
    );
  };

  OnGstInfoClick = () => {
    if (this.validateGstInfo()) {
      this.props.toastErrorMsg("Development Remain..");
    }
  };

  DeleteData = (EditSupplierName) => {
    if (EditSupplierName.length > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Supplier : " + EditSupplierName + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteSupplierMaster(EditSupplierName);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  SaveSupplierMaster = () => {
    if (this.validateSupplierMaster()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveSupplier",
          edit_supplier: this.state.formData.EditSupplierName,
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          vac_company: localStorage.getItem("CompanyName"),
          vac_gstno: this.state.formData.txtGSTNo,
          vac_supplier: this.state.formData.txtSupplierName,
          vac_billingname: this.state.formData.txtBillingName,
          vac_personname: this.state.formData.txtPersonName,
          vac_address: this.state.formData.txtAddress,
          vac_city: this.state.formData.cmbCity,
          vac_state: this.state.formData.cmbState,
          vac_statecode: this.state.formData.txtStateCode,
          vac_panno: this.state.formData.txtPanNo,
          vac_mobileno1: this.state.formData.txtMobileNo1,
          vac_mobileno2: this.state.formData.txtMobileNo2,
          vac_email1: this.state.formData.txtEmail1,
          vac_email2: this.state.formData.txtEmail2,
          vac_openingamountcrdr: this.state.formData.cmbCrDr,
          dec_openingamount: this.state.formData.txtOpeningAmount,
          vac_remark: this.state.formData.txtRemark,
        };
        fetchSupplierMaster(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.getInfo();
              this.clearInfo(true);
            } else {
              this.setState({
                dataLoadStatus: true,
              });
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in SaveSupplier.", error);
          });
      });
    }
  };

  DeleteSupplierMaster = (edit_supplier) => {
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus: false }, () => {
      const reqData = {
        Op: "DeleteSupplier",
        bint_acid: localStorage.getItem("acid"),
        edit_supplier: edit_supplier,
      };
      fetchSupplierMaster(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState({ ARD: null, dataLoadStatus: true }, () => {
              this.getInfo();
              this.clearInfo(true);
            });
          } else {
            this.setState({ dataLoadStatus: true });
          }
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in DeleteSupplier. " + error
          );
        });
    });
    return false;
  };

  openARDGstInfo = () => {
    let vac_gstin = this.state.formData.txtGSTNo;
    if (this.validateGstInfo()) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            alertMessage=<GstInfo
              vac_gstin={vac_gstin.toUpperCase()}
              update={this.update}
            />
            defaultOpenDialog={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  update = (
    legalNameOfBusiness,
    tradeName,
    address,
    gstno,
    state,
    statecode
  ) => {
    this.setState({
      formData: {
        ...this.state.formData,
        txtSupplierName: tradeName,
        txtBillingName: tradeName,
        txtAddress: address.split(", ").slice(0, -4).join(", "),
        txtGSTNO: gstno,
        cmbState: state,
        txtStateCode: statecode,
        txtPANNo: gstno.substring(2, 12),
        cmbCity: address.split(", ").slice(-3, -2)[0] || "",
      },
      ARD: null,
    });
  };
  //#endregion function

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "30px", color: "#515151" }}
            >
              <b>Supplier Master</b>
            </label>
          </Grid>
        )}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtGSTNo"
                  value={this.state.formData.txtGSTNo}
                  label="GST NO"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  isUpperCase={true}
                  maxLength={15}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtSupplierName"
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Get GST Info."
                  onClick={this.openARDGstInfo}
                  variant="outlined"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtSupplierName"
                  value={this.state.formData.txtSupplierName}
                  label="Supplier Name*"
                  handleOnChange={this.handleOnChange}
                  width={230}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtBillingName"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtBillingName"
                  value={this.state.formData.txtBillingName}
                  label="Billing Name"
                  handleOnChange={this.handleOnChange}
                  width={240}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtPersonName"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtPersonName"
                  value={this.state.formData.txtPersonName}
                  label="Person Name"
                  handleOnChange={this.handleOnChange}
                  width={160}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtAddress"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item xs={10} sm={8}>
                <CtMultiLineText
                  id="txtAddress"
                  label="Address"
                  value={this.state.formData.txtAddress}
                  handleOnChange={this.handleOnChange}
                  width="100%"
                  maxLength={100}
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbCity"
                  label="City"
                  items={this.state.CityList}
                  value={this.state.formData.cmbCity}
                  handleOnChange={this.handleOnChange}
                  width={210}
                  maxLength={100}
                  colID="vac_city"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbState"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbState"
                  label="State*"
                  items={this.state.StateList}
                  value={this.state.formData.cmbState}
                  handleOnChange={this.handleOnChange}
                  width={220}
                  maxLength={50}
                  colID="vac_state"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtPanNo"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtStateCode"
                  value={this.state.formData.txtStateCode}
                  label="State Code*"
                  handleOnChange={this.handleOnChange}
                  width={80}
                  disabled={true}
                  maxLength={5}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtPanNo"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtPanNo"
                  isUpperCase={true}
                  value={this.state.formData.txtPanNo}
                  label="PAN NO"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtMobileNo1"
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtMobileNo1"
                  value={this.state.formData.txtMobileNo1}
                  label="Mobile No 1"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtMobileNo2"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxtNum
                  id="txtMobileNo2"
                  value={this.state.formData.txtMobileNo2}
                  label="Mobile No 2"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtEmail1"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtEmail1"
                  value={this.state.formData.txtEmail1}
                  label="Email 1"
                  handleOnChange={this.handleOnChange}
                  width={200}
                  maxLength={50}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtEmail2"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtEmail2"
                  value={this.state.formData.txtEmail2}
                  label="Email 2"
                  handleOnChange={this.handleOnChange}
                  width={200}
                  maxLength={50}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="cmbCrDr"
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="cmbCrDr"
                  label="Cr/Dr"
                  items={this.state.CrDr}
                  value={this.state.formData.cmbCrDr}
                  handleOnChange={this.handleOnChange}
                  width={70}
                  maxLength={10}
                  colID="Type"
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtOpeningAmount"
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxtAmt
                  id="txtOpeningAmount"
                  value={this.state.formData.txtOpeningAmount}
                  label="Opening Amount"
                  handleOnChange={this.handleOnChange}
                  width={150}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtRemark"
                />
              </Grid>
              <Grid item xs={10} sm={8}>
                <CtMultiLineText
                  id="txtRemark"
                  value={this.state.formData.txtRemark}
                  label="Remark"
                  handleOnChange={this.handleOnChange}
                  maxLength={1000}
                  width="100%"
                  onKeyDown={this.props.onKeyDown}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtBtn
                  label="Save"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.SaveSupplierMaster();
                    });
                  }}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant="outlined"
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(this.state.formData.EditSupplierName);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        {/* <TableList
          columns={this.state.columns}
          counter={this.state.counter}
          rows={rows}
          rowsCount={rowsCount}
          rowsPerPage={this.state.rowsPerPage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleOnActionClick={this.handleARDonActionClick}
          actionList={this.state.actionList}
          keyColumn={this.state.keyColumn}
          handleOnSearchChange={this.handleOnSearchChange}
          searchColumns={this.state.searchColumns}
          searchData={this.state.searchData}
          provideSearch={true}
          handleOnNewEntryClick={this.handleOnNewEntryClick}
        /> */}
        <CtART
          rowsdata={this.state.rows}
          columnsdata={this.state.columnsdata}
          rowsPerPage={this.state.rowsPerPage}
          tblmaxHeight={500}
          csvFileName={csvFileName("Customer")}
          rowIconAction={[
            {
              label: "Edit",
              onClick: this.handleARDonActionClick_Edit,
              icon: "Edit",
              className: "secondary-button",
            },
            {
              label: "Delete",
              onClick: this.handleARDonActionClick_Delete,
              icon: "delete",
              className: "delete-button",
            },
            // this.props.userPrivilege["Entry:Proposal"] == "M"
            //   ? {
            //       label: "Delete",
            //       onClick: this.handleARDonActionClick_Delete,
            //       icon: "delete",
            //       className: "delete-button",
            //     }
            //   : "",
          ]}
          // tableButtonAction={[
          //   {
          //     label: "Sales Entry",
          //     onClick: this.handleOnNewEntryClick,
          //     addPluseIcon: true,
          //   },
          //   // this.props.userPrivilege["Entry:Proposal"] != "R"
          //   //   ? {
          //   //       label: "Add New Proposal",
          //   //       onClick: this.handleOnNewEntryClick,
          //   //       addPluseIcon: true,
          //   //     }
          //   //   : "",
          // ]}
          showColumnFilters={false}
          actionColSize={90}
          hideColIdList={["vac_companyname", "vac_customername"]}
          density={"compact"}
        />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(SupplierMaster)));
